import Model from '@/store/model';
import Error from '../model_error';
import Notification from './notification';

class NotificationResponse extends Model {
  map(json) {
    super.map(json);

    if (json.errors !== undefined && json.errors !== null) {
      this.mapArray('errors', json.errors, Error);
    }

    if (json.notifications !== null && json.notifications !== undefined) {
      this.mapArray('notifications', json.notifications, Notification);
    }
  }
}
export default NotificationResponse;
